import MergeTable from './src/MergeTable'
MergeTable.install = function (Vue) {
  Vue.component(MergeTable.name, Modal)
}
export default MergeTable
